export class LoadSubjectsAction {
  static type = '[Pantheon] LoadSubjectsAction';
}

export class LoadIdentsAction {
  static type = '[Pantheon] LoadIdentsAction';
}
